const STORAGE_KEY = 'fiametta-loading-shown';

function clearLsTimers(el) {
  if (el._lsCrossfadeTimer) {
    clearTimeout(el._lsCrossfadeTimer);
    el._lsCrossfadeTimer = null;
  }
  if (el._lsExitTimer) {
    clearTimeout(el._lsExitTimer);
    el._lsExitTimer = null;
  }
}

function initLoadingScreen() {
  const el = document.getElementById('LoadingScreen');
  if (!el) return;

  const durationMs = parseInt(el.dataset.duration, 10) || 3000;
  const once = el.dataset.once === 'true';
  const isDesignMode = Boolean(Shopify?.designMode);

  if (once && !isDesignMode && sessionStorage.getItem(STORAGE_KEY)) {
    removeOverlay(el);
    return;
  }

  playAnimation(el, durationMs, once, isDesignMode);

  if (isDesignMode) {
    setupDesignModeListeners(el, durationMs, once);
  }
}

function playAnimation(el, durationMs, once, isDesignMode) {
  clearLsTimers(el);

  el.setAttribute('aria-hidden', 'false');
  el.style.removeProperty('display');
  el.classList.remove('loading-screen--exit-fade-bg');
  el.classList.add('is-animating');

  const hasBg = el.classList.contains('loading-screen--has-bg');
  const hasLogo = Boolean(el.querySelector('.loading-screen__logo'));

  if (hasLogo) {
    el.classList.remove('loading-screen--bg-reveal');
  }

  if (hasBg && hasLogo) {
    const reduceMotion = Boolean(
      window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    );
    const holdMs = reduceMotion ? 0 : 450;
    el._lsCrossfadeTimer = setTimeout(() => {
      el._lsCrossfadeTimer = null;
      el.classList.add('loading-screen--bg-reveal');
    }, holdMs);
  } else if (hasBg && hasLogo === false) {
    el.classList.add('loading-screen--bg-reveal');
  }

  const exitDelay = Math.max(durationMs - 600, 400);
  el._lsExitTimer = setTimeout(() => {
    el._lsExitTimer = null;
    beginExit(el, once, isDesignMode);
  }, exitDelay);
}

function beginExit(el, once, isDesignMode) {
  clearLsTimers(el);

  if (once && !isDesignMode) {
    sessionStorage.setItem(STORAGE_KEY, '1');
  }

  const bgLayer = el.querySelector('.loading-screen__bg');
  const fadeBgFirst =
    Boolean(bgLayer) && el.classList.contains('loading-screen--bg-reveal');

  if (fadeBgFirst) {
    let shellStarted = false;

    const startShellFade = () => {
      if (shellStarted) return;
      shellStarted = true;
      bgLayer.removeEventListener('transitionend', onBgFadeDone);
      runShellFadeOut(el, isDesignMode);
    };

    const onBgFadeDone = (e) => {
      if (e.target !== bgLayer || e.propertyName !== 'opacity') return;
      startShellFade();
    };

    el.classList.add('loading-screen--exit-fade-bg');
    bgLayer.addEventListener('transitionend', onBgFadeDone);

    const raw = getComputedStyle(el).getPropertyValue('--ls-crossfade-duration');
    const crossfadeMs = parseCssTimeToMs(raw) + 120;
    setTimeout(startShellFade, crossfadeMs);
    return;
  }

  runShellFadeOut(el, isDesignMode);
}

function parseCssTimeToMs(value) {
  const v = (value || '').trim().toLowerCase();
  if (!v) return 1000;
  const n = parseFloat(v);
  if (Number.isNaN(n)) return 1000;
  if (v.endsWith('ms')) return Math.max(1, Math.ceil(n));
  return Math.max(1, Math.ceil(n * 1000));
}

function runShellFadeOut(el, isDesignMode) {
  let finished = false;
  const exitMs = 550;

  function finish() {
    if (finished) return;
    finished = true;
    el.removeEventListener('transitionend', onShellDone);
    el.classList.remove('loading-screen--exit-fade-bg');

    if (!isDesignMode) {
      removeOverlay(el);
    } else {
      el.classList.remove('is-animating', 'loading-screen--bg-reveal');
    }
  }

  function onShellDone(e) {
    if (e.target !== el || e.propertyName !== 'opacity') return;
    finish();
  }

  el.setAttribute('aria-hidden', 'true');
  el.addEventListener('transitionend', onShellDone);
  setTimeout(finish, exitMs);
}

function removeOverlay(el) {
  clearLsTimers(el);
  el.style.display = 'none';

  requestAnimationFrame(() => {
    el.remove();
  });
}

function setupDesignModeListeners(el, durationMs, once) {
  document.addEventListener('shopify:section:select', (e) => {
    if (!e.target.contains(el)) return;
    clearLsTimers(el);
    el.classList.remove(
      'is-animating',
      'loading-screen--bg-reveal',
      'loading-screen--exit-fade-bg'
    );
    el.setAttribute('aria-hidden', 'false');
    el.style.removeProperty('display');

    void el.offsetHeight;
    playAnimation(el, durationMs, once, true);
  });

  document.addEventListener('shopify:section:deselect', (e) => {
    if (!e.target.contains(el)) return;
    clearLsTimers(el);
    el.setAttribute('aria-hidden', 'true');
    el.classList.remove(
      'is-animating',
      'loading-screen--bg-reveal',
      'loading-screen--exit-fade-bg'
    );
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLoadingScreen);
} else {
  initLoadingScreen();
}
